import { render, staticRenderFns } from "./WxLogin.vue?vue&type=template&id=f8ea8e6a&scoped=true&"
import script from "./WxLogin.vue?vue&type=script&lang=js&"
export * from "./WxLogin.vue?vue&type=script&lang=js&"
import style0 from "./WxLogin.vue?vue&type=style&index=0&id=f8ea8e6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ea8e6a",
  null
  
)

export default component.exports